module.exports = __webpack_public_path__ + "static/media/mobile-plan-android.8c61be0c.webp";